import JadwalPertandingan from "../../../../assets/img/illustrations/home-jadwal-pertandingan.svg";
import KlasemenPertandingan from "../../../../assets/img/illustrations/home-klasemen-pertandingan.svg";

export const DATA_TOURNAMENT_CARD = [
  {
    title: "Jadwal",
    imgPath: JadwalPertandingan,
    urlPath: "/jadwal-pertandingan",
    className: "jadwal-pertandingan",
  },
  {
    title: "Klasemen",
    imgPath: KlasemenPertandingan,
    urlPath: "/klasemen-pertandingan",
    className: "klasemen-pertandingan",
  },
];
